import { useSyncExternalStore } from "react";

// Shared across every video in the app. In-memory only, so a page reload resets to muted
// (which also keeps browser autoplay working).
let muted = true;
const listeners = new Set();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
const getSnapshot = () => muted;

export const setVideoMuted = (next) => {
  if (next === muted) return;
  muted = next;
  listeners.forEach((l) => l());
};

export default function useVideoMuted() {
  const isMuted = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return [isMuted, setVideoMuted];
}